import moment from "moment-timezone";
import {useCallback, useMemo, useState} from "react";

export default function useDatePickerControls(
  timezone: string,
  initialCalendarTime: number | null,
) {
  const now = useMemo(() => Math.floor(Date.now() / 10000) * 10000, []);
  const [currentCalendarTime, setCurrentCalendarTime] = useState(initialCalendarTime || now);

  const onPlusDay = useCallback(() => {
    setCurrentCalendarTime(
      calendarTime => +moment(calendarTime).tz(timezone).add(1, "day").startOf("day"),
    );
  }, [setCurrentCalendarTime, timezone]);

  const onMinusDay = useCallback(() => {
    setCurrentCalendarTime(
      calendarTime => +moment(calendarTime).tz(timezone).subtract(1, "day").startOf("day"),
    );
  }, [setCurrentCalendarTime, timezone]);

  return {currentCalendarTime, onPlusDay, onMinusDay};
}
